import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import LandingPage from './pages/LandingPage';
import { useState, useEffect } from 'react';
import axios from 'axios';
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";
import { PaymentPolicy } from "./pages/PaymentPolicy";
import HelpPage from "./pages/Help";
import ScrollToTop from "./components/ScrollToTop";


function App() {
  const [data, setData] = useState(null);
  return (
    <div className="App">
      <Router>
        <ScrollToTop />
          <Routes>
            <Route path="/" element={<div className=''> <LandingPage/> </div>} />
            <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
            <Route path="/terms-of-use" element={<TermsOfUse />} />
            <Route path="/subscription-policy" element={<PaymentPolicy />} />
            <Route path="/help" element={<HelpPage />} />
          </Routes>
      </Router>
    </div>
  );
}

export default App;
